<template>
  <div>
    <vs-popup class="user-edit-popup"
              id="popup"
              title="SALES QUOTE DETAILS"
              :active.sync="open"
              :buttons-hidden="true">
      <vx-card no-shadow >
        <div class="vx-row">
          <div class="vx-col w-full md:w-6/6 mb-8">
            <div class="btn-group float-right">
              <vs-button class="ml-2" color="success" size="small" @click="onClickPrintQuote">Print</vs-button>
            </div>
            <div class="btn-group float-right" v-if="salesQuote.customer_status && salesQuote.customer_status.name === 'Approved'" v-can="'create-so-from-sales-quote'">
              <vs-button class="ml-2" color="warning" size="small" @click="onClickCreateSalesOrder">Create Sales Order</vs-button>
            </div>
          </div>
        </div>
        <div class="mb-3 vx-row">
          <div class="w-full vx-col md:w-1/4 md:mb-0">
            <small class="label"><b>Quote Code</b></small>
            <p>{{salesQuote.quote_code}}</p>
          </div>

          <div class="w-full vx-col md:w-1/4 md:mb-0">
            <small class="label"><b>Created By</b></small>
              <p>{{salesQuote.created_by}}</p>
          </div>
          <div class="w-full vx-col md:w-1/4 md:mb-0">
              <small class="label"><b>Currency</b></small>
              <p>{{salesQuote.customer_account_currency}}</p>
          </div>
          <div class="w-full vx-col md:w-1/4 md:mb-0">
            <small class="label"><b>Customer Account Number</b></small>
              <p><HyperLink :id="salesQuote.customer_id" type="customer">{{salesQuote.customer_account_number}}</HyperLink></p>
          </div>
        </div>
        <div class="mb-3 vx-row">
          <div class="w-full vx-col md:w-1/4 md:mb-0">
              <small class="label"><b>Customer</b></small>
              <HyperLink :id="salesQuote.customer_id" type="customer"><p>{{salesQuote.customer_name}}</p></HyperLink>
          </div>
          <div class="w-full vx-col md:w-1/4 md:mb-0">
            <small class="label"><b>Created At</b></small>
            <p>{{convertDate(salesQuote.created_at)}}</p>
          </div>
          <div class="w-full vx-col md:w-1/4 md:mb-0">
            <small class="label"><b>Account Manager</b></small>
            <p>{{salesQuote.account_manager}} </p>
          </div>
          <div class="w-full vx-col md:w-1/4 md:mb-0">
            <small class="label"><b>FAO</b></small>
            <p v-for="user in salesQuote.fao ">{{user.full_name + ',' || ''}}</p>
          </div>
        </div>
        <div class="mb-3 vx-row">
          <div class="w-full vx-col md:w-1/4 md:mb-0">
            <small class="label"><b>Invoice Address</b></small>
            <div v-if="salesQuote.invoice_address.length !== 0">
              <p class="sml">{{ salesQuote.invoice_address[0].site_name }}</p>
              <p class="sml">{{ salesQuote.invoice_address[0].line1 }}</p>
              <p class="sml">{{ salesQuote.invoice_address[0].line2 }}</p>
              <p class="sml">{{ salesQuote.invoice_address[0].line3 }}</p>
              <p class="sml">{{ salesQuote.invoice_address[0].town_state }}</p>
              <p class="sml">{{ salesQuote.invoice_address[0].post_code }}</p>
              <p class="sml">{{ salesQuote.invoice_address[0].country }}</p>
            </div>
            <div v-else>
              <p class="sml">N/A</p>
            </div>
          </div>
          <div class="w-full vx-col md:w-1/4 md:mb-0">
            <small class="label"><b>Delivery Address</b></small>
            <div v-if="salesQuote.delivery_address.length !== 0">
              <p class="sml">{{ salesQuote.delivery_address[0].site_name }}</p>
              <p class="sml">{{ salesQuote.delivery_address[0].line1 }}</p>
              <p class="sml">{{ salesQuote.delivery_address[0].line2 }}</p>
              <p class="sml">{{ salesQuote.delivery_address[0].line3 }}</p>
              <p class="sml">{{ salesQuote.delivery_address[0].town_state }}</p>
              <p class="sml">{{ salesQuote.delivery_address[0].post_code }}</p>
              <p class="sml">{{ salesQuote.delivery_address[0].country }}</p>
            </div>
            <div v-else>
              <p class="sml">N/A</p>
            </div>
          </div>
          <div class="w-full vx-col md:w-1/4 md:mb-0">
            <small class="label"><b>Term of Payment (Days)</b></small>
            <p>{{ salesQuote.terms_of_payment }}</p>
          </div>
          <div class="w-full vx-col md:w-1/4 md:mb-0">
            <small class="label"><b>Product Orders</b></small>
            <p><HyperLink v-for="(item, index) in salesQuote.product_orders" :key="index" :id="item.id" type="product-order">{{ item.product_order_code }}</HyperLink></p>
          </div>

        </div>
            <vs-table class="my-8" hoverFlat id="quote_item_table" :data="salesQuote.items" stripe>
              <template slot="header">
                <h5 class="mb-4">Quote Items</h5>
              </template>
              <template slot="thead">
                <vs-th>PRODUCT CODE/NAME</vs-th>
                <vs-th>CUSTOMER PRODUCT CODE</vs-th>
                <vs-th>QUANTITY</vs-th>
                <vs-th>PRICE/KG</vs-th>
                <vs-th>PACK SIZE (KG)</vs-th>
                <vs-th>LEAD TIME</vs-th>
                <vs-th>INCOTERMS</vs-th>
                <vs-th>VALID FROM</vs-th>
                <vs-th>VALID TO</vs-th>
                <vs-th>ESTIMATED YEARLY VOLUME (KG)</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="index_item"
                       v-for="(tr_item, index_item) in data">

                  <vs-td :data="data[index_item].product_code_name">
                    <HyperLink :id="data[index_item].formulation.id" type="formulation">{{ data[index_item].product_code_name }}</HyperLink>
                  </vs-td>
                  <vs-td :data="data[index_item].customer_product_code">
                    {{ data[index_item].customer_product_code }}
                  </vs-td>
                  <vs-td>
                    <div>
                      <span v-if="!data[index_item].is_tier">
                        {{ data[index_item].quantity[0].quantity }}
                      </span>
                      <span v-else>
                        <span v-for="(qty_obj, index_obj) in data[index_item].quantity" :key="index_obj">
                          {{ qty_obj.quantity_from }} - {{ qty_obj.quantity_to }} <br>
                        </span>
                      </span>
                    </div>
                  </vs-td>
                  <vs-td :data="data[index_item].price">
                    <span v-for="(price_obj, index_obj) in data[index_item].price" :key="index_obj">
                      {{ price_obj.price }} <br>
                    </span>
                  </vs-td>
                  <vs-td :data="data[index_item].pack_size">
                    {{ data[index_item].pack_size }}
                  </vs-td>
                  <vs-td :data="data[index_item].lead_time">
                    {{ data[index_item].lead_time }} Working days
                  </vs-td>
                  <vs-td :data="data[index_item].incoterms">
                    {{ data[index_item].incoterms }}
                  </vs-td>
                  <vs-td :data="data[index_item].valid_from">
                    {{ data[index_item].valid_from }}
                  </vs-td>
                  <vs-td :data="data[index_item].valid_to">
                    {{ data[index_item].valid_to }}
                  </vs-td>
                  <vs-td :data="data[index_item].estimated_yearly_volume">
                    {{ data[index_item].estimated_yearly_volume || 'N/A'}}
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
            <div class="vx-row" v-if="salesQuote.add_costs.length !== 0">
        <div class="vx-col w-full md:mb-0">
          <vx-card title="Additonal Cost" class="mt-8">
            <vs-table :data="salesQuote.add_costs">

              <template slot="thead">
                <vs-th>NAME/DESCRIPTION</vs-th>
                <vs-th>AMOUNT (Excl VAT) in {{ account_currency }}</vs-th>
                <vs-th>VAT PERCENTAGE (%)</vs-th>
                <vs-th>AMOUNT (Incl VAT) in {{ account_currency }}</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].amount">
                    {{ data[indextr].amount }}
                  </vs-td>

                  <vs-td :data="data[indextr].vat_percent">
                    {{ data[indextr].vat_percent }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ Number(tr.amount * (1 + (Number(tr.vat_percent) / 100))).toFixed(2) }}
                  </vs-td>
                </vs-tr>
              </template>

            </vs-table>
          </vx-card>
        </div>
      </div>  

      </vx-card>
    </vs-popup>
    <SalesQuotePrintView ref="salesQuotePrintView"/>
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const CustomerRepository = RepositoryFactory.get('customer')
import ErrorMessages from "@/mixins/ErrorMessages";
import successMessage from "../../../mixins/SuccessMessage";
import moment from "moment";
import SalesQuotePrintView from "../pdf/SalesQuotePrintView.vue";
export default {
  name: "ViewSalesQuotePopUp",
  data() {
    return {
      id:'',
      salesQuote: {
        invoice_address: [],
        delivery_address: [],
        is_delivery_same_as_invoice_address: 0,
        add_costs: [],
      },
      open:false,
    }
  },
  components:{
    SalesQuotePrintView
  },
  mixins:[ErrorMessages,successMessage],
  methods:{
    async openPopup(id) {
      this.id = id
      await this.fetchSalesQuote()
      this.open = true
    },
    async fetchSalesQuote() {
      await this.$vs.loading()
      try {
        const { data } = await CustomerRepository.getSalesQuote(this.id)
        this.salesQuote = data.data
        if(this.salesQuote.is_delivery_same_as_invoice_address === 1) {
          this.salesQuote.delivery_address = [
            {
              site_name: this.salesQuote.invoice_address[0].site_name,
              line1: this.salesQuote.invoice_address[0].line1,
              line2: this.salesQuote.invoice_address[0].line2,
              line3: this.salesQuote.invoice_address[0].line3,
              town_state: this.salesQuote.invoice_address[0].town_state,
              postal_code: this.salesQuote.invoice_address[0].postal_code,
              country: this.salesQuote.invoice_address[0].country,
            }
          ]
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async onClickCreateSalesOrder() {
      try {
        await this.$vs.loading()
          const response = await CustomerRepository.createSalesOrderFromQuote(this.salesQuote.id)
          if (response.status >= 200 && response.status < 300) {
              const resolved = this.$router.resolve({
                  path: '/pages/product-orders',
                  query: {
                      create: true,
                      quote_id: this.salesQuote.id,
                      customer_id: this.salesQuote.customer_id,
                      account_currency: this.salesQuote.customer_account_currency,
                  }
              })
              window.open(resolved.href, '_blank')
          }
      } catch (e) {
      }finally{
        this.$vs.loading.close()
      }
    },
    convertDate(date){
      return moment(date).format('DD/MM/YYYY')
    },
    onClickPrintQuote() {
      this.$refs.salesQuotePrintView.openPopup(this.salesQuote.id, this.salesQuote.customer_id, this.salesQuote.quote_code)
      this.open = false
      // let routeData = this.$router.resolve({name:'sales-quote-print-view', params:{id:this.id}})
      // window.open(routeData.href,'_blank');
    },
  }
}
</script>

<style scoped>
.user-edit-popup >>> .vs-popup {
  width: 60%;
}
.label {

}

</style>
